import { Grid, Typography } from "@mui/material";
import Appointment from "../interface/appointment";

const getStatusAsText = (appointment: Appointment): string => {
  if (
    appointment.status === "G" &&
    new Date(appointment.date).toISOString().split("T")[0] <
      new Date().toISOString().split("T")[0]
  )
    return "beendet";

  switch (appointment.status) {
    case "G":
      return "gebucht";
    case "F":
      return "frei";
    case "K":
      return "storniert";
    case "V":
      return "versäumt";
    default:
      return "Unbekannt";
  }
};

const RenderAppointmentStatus = ({
  appointment,
}: {
  appointment: Appointment;
}): React.JSX.Element => (
  <Grid
    item
    xs={12}
    sm={6}
    md={1}
    sx={{
      display: appointment.isSpeedcoaching ? "none" : "flex",
      alignItems: "center",
    }}
  >
    <Typography
      variant="body1"
      color="initial"
      sx={{
        wordBreak: "break-all",
        overflowWrap: "break-word",
        whiteSpace: "normal",
      }}
    >
      {getStatusAsText(appointment)}
    </Typography>
  </Grid>
);

export default RenderAppointmentStatus;
